import { Grid, GridItem } from '@thg-commerce/gravity-system'
import { styled, spacing, Text, mq } from '@thg-commerce/enterprise-theme'
import { SafeHtml } from '@thg-commerce/gravity-elements'

export const StyledProductGrid = styled(Grid)`
  margin: 0 0 ${spacing(7)} 0;
`

export const StyledListItem = styled.li`
  margin-top: 0;

  &:last-child {
    ${StyledProductGrid} {
      margin-bottom: 0;
    }
  }
`

export const ProductGridItem = styled(GridItem)`
  margin-left: 0;
  margin-right: 0;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin-bottom: 0;
    margin-right: ${spacing(2)};
  }
`

export const DescriptionGridItem = styled(GridItem)`
  margin-bottom: 0;
  margin-right: 0;
  margin-left: 0;
`

export const TitleGridItem = styled(GridItem)`
  margin-bottom: ${spacing(3)};
  margin-left: 0;
  margin-right: 0;
`

export const ProductTitle = styled.h3`
  ${Text('medium1', 'alternate')};
  cursor: pointer;

  span {
    ${Text('xlarge1', 'alternate')};
    margin-right: ${spacing(2)};
  }
`

export const StyledText = styled(SafeHtml)`
  ul {
    white-space: normal;
  }

  em {
    font-style: italic;
  }

  strong {
    ${Text('bodyText', 'alternate')};
  }
`
